var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticStyle:{"text-align":"center"}},[_c('b-badge',[_vm._v(" Next Step: "),_c('br',{staticClass:"mobile"}),_vm._v(" "+_vm._s(_vm.nextStepText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }